import axiosServices from 'utils/axios';
import { MeResponseDto } from 'types/menu';

// ==============================|| ME SERVICE - GET /Users/GetCurrentUser ||============================== //

/**
 * Fetches the current user profile along with roles, menus, and permissions.
 * Called after a successful login to hydrate the application state.
 */
function extractMePayload(resData: unknown): MeResponseDto {
  if (resData == null || typeof resData !== 'object') {
    throw new Error('GetCurrentUser: empty response');
  }
  const b = resData as Record<string, unknown>;
  // ApiResponse<MeResponseDto> → data; algunos entornos serializan Data (PascalCase)
  const inner = (b.data ?? b.Data ?? b) as unknown;
  if (inner == null || typeof inner !== 'object') {
    throw new Error('GetCurrentUser: missing payload');
  }
  return inner as MeResponseDto;
}

export const getCurrentUser = async (): Promise<MeResponseDto> => {
  const res = await axiosServices.get<unknown>('/Users/GetCurrentUser');
  return extractMePayload(res.data);
};
